import { useCallback, useMemo } from "react"
import { useContextSelector as useCS } from "use-context-selector"
import { ErrorScreen } from "@unlimint/admin-ui-kit"

import { useTranslate } from "infrastructure/hooks/useTranslate"

import { FormModeEnum } from "domain/enums/FormModeEnum"
import { FormContainer } from "domain/core/containers/FormContainer"
import { insertToGridDataState } from "domain/core/utils"
import { GlobalConfigContext } from "domain/globalConfig/GlobalConfigContext"
import { globalConfigSelectors } from "domain/globalConfig/selectors"

import { AddWebhookForm } from "view/pages/devSpace/WebhooksPage/components/AddWebhookForm"

import { validate } from "./validate"
import { WebhookContext } from "../WebhookContext"
import { webhookSelectors } from "../selectors"
import { dataToRow, mapToReqModel } from "../mappers"
import { formatEventLabelType } from "../utils"

const initialValues = {
  url: "https://",
  name: "",
  apiVersion: "v2",
  isActive: true,
  events: [],
  headers: [],
}

export const AddWebhookContainer = ({ modal }) => {
  const addTitle = useTranslate("pages.webhooks.modals.addTitle")
  const addButton = useTranslate("pages.webhooks.modals.addButton")

  const gridData = useCS(WebhookContext, webhookSelectors.gridData)
  const update = useCS(WebhookContext, webhookSelectors.update)
  const webhookEvents = useCS(
    GlobalConfigContext,
    globalConfigSelectors.webhookEvents
  )

  const disabled = !webhookEvents
  const eventOptions = useMemo(() => {
    if (!webhookEvents?.data) return null
    return Object.keys(webhookEvents.data).map((key) => ({
      label: formatEventLabelType(key),
      value: key,
    }))
  }, [webhookEvents])

  const cbSuccess = useCallback(
    (data) => {
      update({
        gridData: insertToGridDataState(gridData, dataToRow(data.webhook)),
      })
    },
    [gridData, update]
  )

  if (webhookEvents?.error)
    return (
      <ErrorScreen errorText="Unable to Create Webhook. Try again later." />
    )
  if (!eventOptions) return null

  return (
    <FormContainer
      mode={FormModeEnum.Add}
      validate={validate}
      initialValues={initialValues}
      url="/v1/webhooks"
      Form={AddWebhookForm}
      mapToReqModel={mapToReqModel}
      formProps={{
        title: addTitle,
        actionButtonTitle: addButton,
        onClose: modal.onClose,
        disabled,
        eventOptions,
        webhookEvents,
      }}
      cbSuccess={cbSuccess}
    />
  )
}
